
<template>
  <v-container v-if="permitted == false && permitted != null" class="pt-0" fluid>
    <v-dialog v-model="permitted_dialog" max-width="400px">
      <v-card>
        <v-card-text>
          <div class="text-center">
            <div class="title font-weight-light pt-2"><v-icon class="mr-1">mdi-shield-lock-outline</v-icon>Security Error</div>
            <p>{{message}}</p>
            <v-progress-circular
              :size="70"
              :width="2"
              :value="100"
              color="error"
              class="mb-4 mr-4"
            >
              <v-icon color="red" x-large>mdi-exclamation-thick</v-icon>
            </v-progress-circular>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
  <v-container v-else v-show="permitted != null" class="pt-0" fluid>
    <v-snackbar
      :value="showMessage()"
      multi-line
      color="#686868"
      top
      
    >
      {{message}}
    </v-snackbar>
    <v-card flat >
    <v-toolbar dense flat color="#2A353D">
      <v-toolbar-title class="white--text subtitle-1 font-weight-normal">{{heading}}</v-toolbar-title>
      <v-spacer/>
      <v-btn fab x-small outlined color="#81DBF6" class="mr-1" v-if="edit == true || create == true" @click="view = false; closeCreate(); closeEdit()"><v-icon>mdi-chevron-left</v-icon></v-btn>
      <v-btn fab x-small outlined color="#81DBF6" @click="$router.push('/Home')"><v-icon>mdi-close</v-icon></v-btn>

      <v-progress-linear
        :active="loading"
        :indeterminate="loading"
        absolute
        bottom
        color="#81DBF6"
      ></v-progress-linear>
    </v-toolbar>
    </v-card>

    <v-alert
      class="my-2"
      dense text
      color="#2A353D"
    >
      <v-row align="center" class="mx-2 mb-3">
        <v-col class="py-0">
          <v-select
            @change="getLiabilitiesAccrual()"
            hide-details
            filled rounded background-color="white" dense clearable
            v-model="parameters.CustodialID"
            :items="allCustodians.filter(a => a.CheckerID != 0 && a.RejectionID == 0)"
            class="mx-1"
            item-text="CustodianName"
            item-value="CustodianID"
            placeholder="----"
            :rules="TextFieldRules"
            label="Custodian"
          ></v-select>
        </v-col>
        <v-col class="py-0">
          <v-select
            @change="getLiabilitiesAccrual()"
            hide-details
            filled rounded background-color="white" dense clearable
            v-model="parameters.CounterPartyID"
            :items="allCounterparties.filter(a => a.CheckerID != 0 && a.RejectionID == 0)"
            class="mx-1"
            item-text="CounterPartyName"
            item-value="CounterPartyID"
            placeholder="----"
            :rules="TextFieldRules"
            label="Counter Party"
          ></v-select>
        </v-col>
        <v-col class="py-0">
          <v-select
            @change="getLiabilitiesAccrual()"
            hide-details
            filled rounded background-color="white" dense clearable
            v-model="parameters.InstrumentID"
            class="mx-1"
            :items="allInstrumentTypes.filter(a => a.CheckerID != 0 && a.RejectionID == 0)"
            item-text="InstrumentTypeCode"
            item-value="InstrumentTypeID"
            placeholder="----"
            :rules="TextFieldRules"
            label="Instrument"
          ></v-select>
        </v-col>
      </v-row>
      <v-row align="center" class="mx-2">
        <v-col class="py-0">
          <v-menu
            ref="menu"
            v-model="menu"
            :close-on-content-click="false"
            :return-value.sync="parameters.StartDate"
            transition="scale-transition"
            offset-y
            min-width="290px"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="parameters.StartDate"
                class="mx-1"
                label="Start Date"
                append-icon="mdi-calendar-month"
                readonly placeholder="--/--/--"
                hide-details
                dense filled rounded background-color="white" color="#2A353D"
                :rules="TextFieldRules"
                v-bind="attrs"
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker @change="getLiabilitiesAccrual()" color="#2A353D" v-model="parameters.StartDate" no-title scrollable>
            <v-spacer></v-spacer>
            <v-btn outlined small color="#2A353D" @click="menu = false">Cancel</v-btn>
            <v-btn outlined small color="#2A353D" @click="$refs.menu.save(parameters.StartDate)">OK</v-btn>
            </v-date-picker>
          </v-menu>
        </v-col>
        <v-col class="py-0">
          <v-menu
            ref="menu2"
            v-model="menu2"
            :close-on-content-click="false"
            :return-value.sync="parameters.EndDate"
            transition="scale-transition"
            offset-y
            min-width="290px"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="parameters.EndDate"
                class="mx-1"
                label="End Date"
                append-icon="mdi-calendar-month"
                readonly placeholder="--/--/--"
                hide-details
                dense filled rounded background-color="white" color="#2A353D"
                :rules="TextFieldRules"
                v-bind="attrs"
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker @change="getLiabilitiesAccrual()" color="#2A353D" v-model="parameters.EndDate" no-title scrollable>
            <v-spacer></v-spacer>
            <v-btn outlined small color="#2A353D" @click="menu2 = false">Cancel</v-btn>
            <v-btn outlined small color="#2A353D" @click="$refs.menu2.save(parameters.EndDate)">OK</v-btn>
            </v-date-picker>
          </v-menu>
        </v-col>
      </v-row>
    </v-alert>

    <v-data-table
      :fixed-header="true"
      :headers="headers"
      :items="liabilities_accrual"
      :search="search"
      :height="520"
      hide-default-footer
      disable-pagination
      @current-items="getFiltered"
      class="elevation-12 mt-2"
    >

      <template v-slot:top>
        <v-container row>
          <v-text-field
            class="ml-3"
            hide-details
            outlined
            placeholder="search..."
            v-model="search"
            append-icon="mdi-magnify"
            dense
          ></v-text-field>

          <v-spacer></v-spacer>

          <v-menu open-on-hover offset-y>
            <template v-slot:activator="{ on, attrs }">
            <v-btn v-on="on" v-bind="attrs" outlined small color="#2A353D" class="ml-2">
              EXPORT<v-icon class="ml-1" small>mdi-exit-to-app</v-icon>
            </v-btn>
            </template>
            <v-list dense>
            <v-list-item class="ma-0 pa-0">
              <v-btn @click="generatePDF(false)" text small color="#2A353D">
                <v-icon class="mr-1" small>mdi-file-pdf-box</v-icon>TO PDF
              </v-btn>
            </v-list-item>
            <v-list-item class="ma-0 pa-0">
              <v-btn text small color="#2A353D">
                <download-excel
                  :data   = "CurrentLiabilityAccrual"
                  type    = "xls"
                  name    = "Accruals-Liabilities.xls">
    
                  <v-icon class="mr-1" small>mdi-microsoft-excel</v-icon>TO EXCEL
                </download-excel>
              </v-btn>
            </v-list-item>
            <v-list-item class="ma-0 pa-0">
              <v-btn text small color="#2A353D">
                <download-excel
                  :data   = "CurrentLiabilityAccrual"
                  type    = "csv"
                  name    = "Accruals-Liabilities.csv">
    
                  <v-icon class="mr-1" small>mdi-file-document-outline</v-icon>TO CSV
                </download-excel>
              </v-btn>
            </v-list-item>
            </v-list>
          </v-menu>
          <v-btn @click="generatePDF(true)" outlined small color="#2A353D" class="ml-2" v-on="on">
            PRINT<v-icon class="ml-1" small>mdi-printer</v-icon>
          </v-btn>
        </v-container>
      </template>

    </v-data-table>
  </v-container>
</template>

<script>
import reportsService from '../services/reports.service';
import UserService from '../services/user.service';
import {mapGetters} from "vuex";
import jsPDF from 'jspdf';
import 'jspdf-autotable'

export default {
  data () {
    return {
      parameters: {},
      liabilities_accrual: [],
      CurrentLiabilityAccrual: [],
      valid: true,
      filter_dialog: false,
      loading: false,
      permitted: null,
      permitted_dialog: true,
      search: '',
      message: '',
      menu: false,
      heading: "Accruals - Liabilities",
      menu2: false,
      headers: [
        { text: 'DealDate', align: 'start', sortable: false, value: 'DealDate', width:110 },
        { text: 'Instrument', value: 'Instrument', sortable: false },
        { text: 'Counterparty', value: 'Counterparty', sortable: false, width:200 },
        { text: 'Custodian', value: 'Custodian', sortable: false, width:210 },
        { text: 'Amount', value: 'Amount', sortable: false, align: 'end' },
        { text: 'Rate', value: 'Rate', sortable: false, align: 'end' },
        { text: 'MaturityDate', value: 'MaturityDate', sortable: false, align: 'end', width:110 },
        { text: 'OriginalDays', value: 'OriginalDays', sortable: false, align: 'end' },
        { text: 'DaysRun', value: 'DaysRun', sortable: false, align: 'end' },
        { text: 'DaysToMaturity', value: 'DaysToMaturity', sortable: false, align: 'end' },
        { text: 'AccruedInterest', value: 'AccruedInterest', sortable: false, align: 'end' },
      ],
    }
  },

  computed: {
    ...mapGetters([
      "currentImage",
      "allCustodians",
      "identity",
      "allCountries",
      "allCities",
      "currentSystemDate",
      "allCounterparties",
      "allInstrumentTypes"
    ]),

    currentUser() {
      return this.$store.state.auth.user;
    },

  },

  created(){
    this.parameters = {
      CounterPartyID: 0,
      CustodialID: 0,
      InstrumentID: 0,
      StartDate: '2021-01-01',
      EndDate: this.currentSystemDate.DayDate
    }
    this.loading = true;
    reportsService.getLiabilitiesAccrual(this.parameters)
    .then(response => {
      this.liabilities_accrual = response.data;
      this.loading = false
    },
    error => {
    this.message =
      (error.response && error.response.data.message) ||
      error.message ||
      error.toString();
      this.loading = false
    })
  },

  methods: {
    async getLiabilitiesAccrual() {
      if(this.parameters.CounterPartyID == null || this.parameters.CounterPartyID == ''){
        this.parameters.CounterPartyID = 0
      }
      if(this.parameters.InstrumentID == null || this.parameters.InstrumentID == ''){
        this.parameters.InstrumentID = 0
      }
      if(this.parameters.CustodialID == null || this.parameters.CustodialID == ''){
        this.parameters.CustodialID = 0
      }
      if (this.parameters.StartDate != null && this.parameters.EndDate != null) {
        this.loading = true;
        reportsService.getLiabilitiesAccrual(this.parameters)
        .then(response => {
          this.liabilities_accrual = response.data;
          this.loading = false
        },
        error => {
        this.message =
          (error.response && error.response.data.message) ||
          error.message ||
          error.toString();
          this.loading = false
        })
      }
    },
    generatePDF(IsPrint) {
      const columns = [
        { title: 'Deal Date', dataKey: 'DealDate' },
        { title: 'Instrument', dataKey: 'Instrument' },
        { title: 'Counterparty', dataKey: 'Counterparty' },
        { title: 'Custodian', dataKey: 'Custodian' },
        { title: 'Amount', dataKey: 'Amount' },
        { title: 'Rate', dataKey: 'Rate' },
        { title: 'Maturity Date', dataKey: 'MaturityDate' },
        { title: 'Original Days', dataKey: 'OriginalDays' },
        { title: 'Days Run', dataKey: 'DaysRun' },
        { title: 'Days to Maturity', dataKey: 'DaysToMaturity' },
        { title: 'Accrued Interest', dataKey: 'AccruedInterest' }
      ];

      const addFooters = doc => {
        const pageCount = doc.internal.getNumberOfPages()

        for (var i = 1; i <= pageCount; i++) {
          var imgData = 'data:image/png;base64,'+ this.currentImage[0].data;

          doc.addImage(imgData, 'PNG', 0.5, 0.28, 1.3, 0.7);
          doc.setPage(i)
          // text is placed using x, y coordinates
          doc.setFontSize(10).text(this.identity[0].OrgName, 6, 0.5);
          doc.setFontSize(6).text(this.identity[0].Phadd1, 6, 0.6);
          doc.setFontSize(6).text(this.allCities.filter(a => a.CityID == this.identity[0].PhCity).map(a => a.City)[0], 6, 0.7);
          doc.setFontSize(6).text(this.allCountries.filter(a => a.CountryId == this.identity[0].PhCountry).map(a => a.CountryName)[0], 6, 0.8);
          doc.setFontSize(6).text('email: ' + this.identity[0].OrgMail, 6, 0.9);
          doc.setFontSize(6).text('cell: ' + this.identity[0].OrgNumber, 6, 1.0);
          doc.setFontSize(10).text(this.heading, 0.5, 1.2);
          doc.setFontSize(8).text((this.parameters.CustodialID > 0? 'Custodian: ' + this.allCustodians.filter(a => a.CustodianID == this.parameters.CustodialID).map(a => a.CustodianName) + '        ' : '') + (this.parameters.CounterPartyID > 0? 'Counterparty: ' + this.allCounterparties.filter(a => a.CounterPartyID == this.parameters.CounterPartyID).map(a => a.CounterPartyName) + '        ' : '') + (this.parameters.InstrumentID > 0? 'Instrument: ' + this.allInstrumentTypes.filter(a => a.InstrumentTypeID == this.parameters.InstrumentID).map(a => a.InstrumentTypeCode) : ''), 0.5, 1.4);
          // create a line under heading
          doc.setLineWidth(0.01).line(0.5, 1.5, 8, 1.5);
          doc.setLineWidth(0.01).line(0.5, 1.7, 8, 1.7);
          doc.setFontSize(6).text('Page ' + String(i) + ' of ' + String(pageCount), 4.3, 10.7, {
            align: 'center'
          })
        }
      }

      let doc = new jsPDF({
        orientation: "potrait",
        unit: "in",
        format: "letter"
      });

      doc.setFont('helvetica');
      doc.setFontSize(5);
      doc.autoTable({
        columns,
        body: this.CurrentLiabilityAccrual,
        margin: { left: 0.5, top: 1.5 },
        styles: {overflow: 'linebreak',
                fontSize: 6},
        showHeader: 'everyPage',
        theme: 'plain'
      });
      addFooters(doc);
      if(IsPrint == true){
        doc.output('dataurlnewwindow');
      } else{
        doc.save('Accruals-Liabilities.pdf')
      }
    },
    getFiltered(current){
      this.CurrentLiabilityAccrual = current;
    },
    showMessage(){
      if(this.message){
        return true
      } else {
        return false
      }
    },
    validate () {
      this.$refs.form.validate()
      return this.valid
    },

    reset () {
      this.$refs.form.reset()
    },
  },

  mounted () {
    UserService.isReports().then(
      () => {
        this.permitted = true;
        this.message = '';
      },
      error => {
        this.permitted = false;
        this.message =
          (error.response && error.response.data.message) ||
          error.message ||
          error.toString();
      }
    );
  }
}
</script>

<style scoped>
.v-btn {
  outline: none
}
</style>